/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Summerinocctemperaturesetpoint3Inputs */



/**
* | output |
* | --- |
* | "Summer unoccupied heating setpoint" |
*
* @param {Ahu_History_Key_Summerinocctemperaturesetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_summerinocctemperaturesetpoint3 = /** @type {((inputs?: Ahu_History_Key_Summerinocctemperaturesetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Summerinocctemperaturesetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer unoccupied heating setpoint")
	return /** @type {LocalizedString} */ ("Consigne chaud inoccupation été")
});
export { ahu_history_key_summerinocctemperaturesetpoint3 as "ahu_history_key_summerInoccTemperatureSetpoint" }